import { ListProductsPage } from "./pages"

export default [
  { path: "/products", name: "productList", component: ListProductsPage },
]
